import type React from 'react';

import { ConsultationCard } from '@widgets/consultations';

import { ButtonAssign, InfiniteList } from '@features/consultations';

import { Nav } from '@shared/ui';

import { Container } from 'library/components/ui';

import * as st from './styles.module.scss';

export const ConsultationsMain: React.FC = () => {
	return (
		<Container>
			<div className={st.consultations}>
				<section className={st.consultations__nav}>
					<Nav>
						<div />
						<ButtonAssign />
					</Nav>
				</section>
				<section className={st.consultations__list}>
					<InfiniteList>{(id: number) => <ConsultationCard id={id} />}</InfiniteList>
				</section>
			</div>
		</Container>
	);
};
